import { UserInterests } from 'generated/graphql';
import { UUID } from 'v2/core/entities/uuid';
import {
  shouldLogAnalyticsEvents,
  shouldSendAnalyticsEvents,
} from './analytics';

type TenantTraits = {
  tenantId: UUID;
  tenantName: string;
};

type UserTraits = {
  firstName: string;
  lastName: string;
  email: string;
  tenant: TenantTraits;
  interests?: {
    keywords: UserInterests['keywords'];
    labelIDs: UserInterests['labelIDs'];
  };
};

const createAnalyticsIdentifier = <T>() => {
  return (userID: string, traits: T): void => {
    if (shouldSendAnalyticsEvents()) {
      window.analytics.identify(userID, traits);
    } else {
      if (shouldLogAnalyticsEvents()) {
        console.log('IDENTIFY ->', userID, traits);
      }
    }
  };
};

export const Identify = createAnalyticsIdentifier<UserTraits>();
